import React from "react";
// import jwt from "jsonwebtoken";
import axios from "./axios";
import store from "../store";
import { LOAD_TOKEN, AUTH_ERROR } from "../actions/type";
import jwt_decode from "jwt-decode";
import { baseURL } from "./url";
import { decrypt } from "./encodingdecoding";
// import { jwtDecode } from 'jwt-decode';

const EXPIRY_BUFFER_MS = 30 * 1000; // 30 seconds buffer

export const decodeTokenExpiry = (token) => {
  try {
    const decoded = jwt_decode(token);
    return decoded.exp * 1000;
  } catch {
    return 0;
  }
};

export const isTokenExpiredOrExpiring = (
  token,
  bufferMs = EXPIRY_BUFFER_MS,
) => {
  const expiry = decodeTokenExpiry(token);
  if (!expiry) return true;

  const now = Date.now();
  return expiry <= now + bufferMs;
};

export const isTokenExpired = (token) => {
  if (!token) return new Promise((resolve) => resolve(false));
  const now = new Date();
  if (token && jwt_decode(token)) {
    const expiry = jwt_decode(token);
    return new Promise((resolve) =>
      resolve(now.getTime() / 1000 + 60 < expiry.exp),
    );
  }
  return new Promise((resolve) => resolve(false));
};

export const getNewAuthToken = async () => {
  let body = {
    clientid: localStorage.getItem("clientid"),
    grant_type: "client_credentials",
    clientsecret: localStorage.getItem("clientsecret"),
  };
  const { dispatch } = store;
  try {
    localStorage.removeItem("token_gen");
    const fetchResponse = await fetch(baseURL + "internaltoken", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    // fetchResponse.json().then((res) => {
    //     console.log(JSON.stringify(res))
    //     localStorage.setItem("token_gen",JSON.stringify(res));
    //     dispatch({ type: LOAD_TOKEN, payload: res.access_token });
    //     return fetchResponse.json();

    // })
    return await fetchResponse.json();
  } catch (err) {
    dispatch({ type: AUTH_ERROR });
    return new Promise((resolve) => resolve(null));
  }
};

// async handleLogout(err) {
//     const status = err?.response?.status;
//     if (status === 403) return store.dispatch({ type: AUTH_ERROR });
//     if (status === 408) return store.dispatch({ type: AUTH_ERROR });
//     if (status === 418) {
//         const { dispatch } = store;
//         localStorage.removeItem("token");
//         const res = await axios.post("/api/authenticate");
//         const { token } = res.data.results;
//         dispatch({ type: LOAD_TOKEN, payload: token });
//         return store.dispatch({ type: AUTH_ERROR });
//     }
// }
// }

// export default new Utils();

export const CLIENT_ID = decrypt(localStorage.getItem("clientid"));
export const SECRET_KEY = decrypt(localStorage.getItem("clientsecret"));

export function buildQuery(baseUrl, params) {
  const queryString = Object.entries(params)
    .filter(
      ([_, value]) => value !== null && value !== undefined && value !== "",
    )
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`,
    )
    .join("&");

  return queryString ? `${baseUrl}?${queryString}` : baseUrl;
}

export function sortByCategory(data) {
  const grouped = data.reduce((acc, item) => {
    const category = item.category || "Unknown";
    if (!acc[category]) acc[category] = [];
    acc[category].push({
      ...item,
      category,
      category_code: item.category_code || "NA",
    });
    return acc;
  }, {});

  const sortedCategories = Object.keys(grouped).sort();

  const sortedGrouped = {};
  for (const category of sortedCategories) {
    sortedGrouped[category] = grouped[category];
  }

  return sortedGrouped;
}

export function rearrangeAgentFields(schema) {
  const priorityKeys = ["agentFirstName", "agentLastName"];
  const reordered = {};

  priorityKeys.forEach((key) => {
    if (schema[key]) {
      reordered[key] = schema[key];
    }
  });

  const hasGst = !!schema["gstno"];

  Object.keys(schema).forEach((key) => {
    if (priorityKeys.includes(key)) return;
    if (key === "pancard" && hasGst) return;

    reordered[key] = schema[key];

    if (key === "gstno" && schema["pancard"]) {
      reordered["pancard"] = schema["pancard"];
    }
  });

  return reordered;
}

export const patcornMerchantId = "MER010200";
export const sobiscoMerchantId = "MER000430";
export const novoNordiskMerchantId = "MER010195";
export const edsringMerchantId = "MER000385";
export const starHealthMerchantId = "MER000431";
export const gencrestMerchantId = "MER000479";
export const arjunMerchantId = "MER000491";
export const starblazeMerchantId = "MER000497";
export const finodayaCapital = "MER000503";
export const herohousingMerchantId = "MER000500";
export const movodreamMerchantId = "MER000494";
export const movodreamStagingMerchantId = "MER000570";
export const creditInstaMerchantId = "MER000580";
// export const movodreamMerchantId = "MER000531";

export const adminEmail = "admin11@starblazeindia.com";
export const salesEmail = "sales@starblazeindia.com";

export const getUserTypeOptions = (merchantId) => {
  const isSobisco = merchantId === "MER000430";

  if (isSobisco) {
    return [
      { label: "Distributor", value: "Distributor", customerType: "D" },
      { label: "Wholesaler", value: "Wholesaler", customerType: "W" },
      { label: "Sales", value: "Sales", customerType: "S" },
    ];
  }

  return [
    { label: "Distributor", value: "Distributor", customerType: "D" },
    { label: "Retailers", value: "Retailer", customerType: "R" },
    { label: "Customer", value: "CustomerCP", customerType: "C" },
    { label: "Influencer", value: "Influencer", customerType: "I" },
    { label: "Admin User", value: "Admin", customerType: "A" },
  ];
};

export const stateOption = [
  { label: "Arunachal Pradesh", value: "Arunachal Pradesh" },
  { label: "Assam", value: "Assam" },
  { label: "Bihar", value: "Bihar" },
  { label: "Chhattisgarh", value: "Chhattisgarh" },
  { label: "Goa", value: "Goa" },
  { label: "Gujarat", value: "Gujarat" },
  { label: "Haryana", value: "Haryana" },
  { label: "Himachal Pradesh", value: "Himachal Pradesh" },
  { label: "Jharkhand", value: "Jharkhand" },
  { label: "Karnataka", value: "Karnataka" },
  { label: "Kerala", value: "Kerala" },
  { label: "Madhya Pradesh", value: "Madhya Pradesh" },
  { label: "Maharashtra", value: "Maharashtra" },
  { label: "Manipur", value: "Manipur" },
  { label: "Meghalaya", value: "Meghalaya" },
  { label: "Mizoram", value: "Mizoram" },
  { label: "Nagaland", value: "Nagaland" },
  { label: "Odisha", value: "Odisha" },
  { label: "Punjab", value: "Punjab" },
  { label: "Rajasthan", value: "Rajasthan" },
  { label: "Sikkim", value: "Sikkim" },
  { label: "Tamil Nadu", value: "Tamil Nadu" },
  { label: "Telangana", value: "Telangana" },
  { label: "Tripura", value: "Tripura" },
  { label: "Uttar Pradesh", value: "Uttar Pradesh" },
  { label: "Uttarakhand", value: "Uttarakhand" },
  { label: "West Bengal", value: "West Bengal" },
  {
    label: "Andaman and Nicobar Islands",
    value: "Andaman and Nicobar Islands",
  },
  { label: "Chandigarh", value: "Chandigarh" },
  {
    label: "Dadra and Nagar Haveli and Daman and Diu",
    value: "Dadra and Nagar Haveli and Daman and Diu",
  },
  { label: "Delhi", value: "Delhi" },
  { label: "Jammu and Kashmir", value: "Jammu and Kashmir" },
  { label: "Ladakh", value: "Ladakh" },
  { label: "Lakshadweep", value: "Lakshadweep" },
  { label: "Puducherry", value: "Puducherry" },
];

export const getUserDetail = [
  { label: "Distributor Number", value: "distMobile" },
  { label: "Sales Number", value: "SalesNumber" },
];
